import { apiClient } from "lib/apiClient";
import {
  IResearchTransitionRequest,
  IResearchWorkItem,
} from "features/Research/types";

export const transitionResearchWorkItem = async (
  workItemId: string,
  request: IResearchTransitionRequest
): Promise<IResearchWorkItem> => {
  const response = await apiClient.post(
    `/research/work-items/${workItemId}/transitions`,
    request
  );
  return response.data;
};
